/*

ThreeJs custom waves
Original script by ThreeJS : https://threejs.org/examples/canvas_particles_waves.html
Modified version for Cloudoru by Kevin Rajaram : http://kevinrajaram.com
Date: 08/14/2014
*/

import * as THREE from 'three'
import $ from 'jquery'

let SEPARATION = 80, AMOUNTX = 80, AMOUNTY = 40;

let container;
let camera, scene, renderer;

let particles, particle, count = 0;

let windowHalfX = window.innerWidth / 2;
let windowHalfY = window.innerHeight / 2;

let aniStarted = false

function drawWaves() {
  init()
  if(!aniStarted) {
    animate()
  }
}

function resetWaves($el) {
  scene = null;
  camera = null;
  empty($el);
}

function empty($el) {
  while ($el.lastChild) $el.removeChild($el.lastChild);
}

function init() {
  let $waveContainer = $('#sc-page-waves')

  if(camera) {
    resetWaves($waveContainer)
  }
  $waveContainer.html('')
  container = $waveContainer.get(0)

  camera = new THREE.PerspectiveCamera( 120, window.innerWidth / window.innerHeight, 500, 10000 );
  camera.position.y = 10; //changes how far back you can see i.e the particles towards horizon
  camera.position.z = 150; //This is how close or far the particles are seen

  camera.rotation.x = 0.8;
  // camera.rotation.y = 0.75;
  // camera.rotation.z = 0.75;

  scene = new THREE.Scene();

  particles = [];

  let dotGeometry = new THREE.Geometry();
  dotGeometry.vertices.push(new THREE.Vector3( 0, 0, 0));
  let dotMaterial = new THREE.PointsMaterial( {color: 0xba2713, size: 1.4, sizeAttenuation: false } );

  let i = 0;

  for ( let ix = 0; ix < AMOUNTX; ix ++ ) {

    for ( let iy = 0; iy < AMOUNTY; iy ++ ) {

      particle = particles[ i ++ ] = new THREE.Points( dotGeometry, dotMaterial );
      particle.position.x = ix * SEPARATION - ( ( AMOUNTX * SEPARATION ) / 2 ) + Math.random() * 197;
      particle.position.z = iy * SEPARATION - ( ( AMOUNTY * SEPARATION ) - 10 ) + Math.random() * 197;
      scene.add( particle );

    }

  }

  renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
  renderer.setSize( window.innerWidth, window.innerHeight );
  renderer.setClearColor( 0xffffff, 0);
  container.appendChild( renderer.domElement );

  window.addEventListener( 'resize', onWindowResize, false );

}

function onWindowResize() {

  windowHalfX = window.innerWidth / 2;
  windowHalfY = window.innerHeight / 2;

  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();

  renderer.setSize( window.innerWidth, window.innerHeight );

}

function animate() {
  aniStarted = true
  requestAnimationFrame( animate );
  render();
}

function render() {

  let i = 0;

  for ( let ix = 0; ix < AMOUNTX; ix ++ ) {

    for ( let iy = 0; iy < AMOUNTY; iy ++ ) {

      particle = particles[ i++ ];
      particle.position.y = ( Math.cos( ( ix + count ) * 0.5 ) * 40 ) + ( Math.cos( ( iy + count ) * 0.5 ) * 40 );
      particle.scale.x = particle.scale.y = ( Math.sin( ( ix + count ) * 0.3 ) + 2 ) * 40 + ( Math.sin( ( iy + count ) * 0.5 ) + 1 ) * 40;
    }

  }

  renderer.render( scene, camera );

  // This increases or decreases speed
  count += 0.025;
}

export {
  drawWaves
}